 <template>
  <div>
    <header-sales></header-sales>

    <!-- pc view  -->
    <div v-if='!mobileView'>
        <div id="subheader"> </div>
        <div id="main-container" style="top: 50vh; height: 90vh;">

        <div class="fv lc" style="width: 700px; height: 10vh">
            <span id="label">Ver Pedido</span>
        </div>

        <div id= "container" style="height: 82vh">
            <div class="fh lc" style="width: 100%; height: 65px" > 
                <div class="fh lc" style="width: 23%; height: 100%; margin-left: 23px;"> 
                   <div :id="`circulo${estadoPedido}`"  style="margin-left:10px"> </div>
                   <div style="font-size:13px; font-weight: 400; color:#5D6770; margin-left: 5px">{{estado(estadoPedido)}} </div>
                </div>
            </div>
            <div id="list-container">
                <item-pedido id="list-prod" v-for="item in productosCP" :item='item' ></item-pedido>
            </div>
            <div class="fv rc" style="width: 100%; margin-top: 10px">
                <div class="fh cc" style="margin-right: 40px">
                  <div style="font-size: 11px; color:#5D6770"> Subtotal: </div>
                  <div class="fh rc" style="width: 150px; font-size: 11px; color:#5D6770"> ${{subtotal | formatMoney}} </div>
                </div>
                <div class="fh cc" style="margin-right: 40px">
                  <div style="font-size: 11px; color:#5D6770"> Descuentos: </div>
                  <div class="fh rc" style="width: 150px; font-size: 11px; color:#5D6770"> ${{descuentosCP | formatMoney}} </div>
                </div>
                <div class="fh cc" style="margin-right: 40px">
                  <div style="font-size: 11px; color:#5D6770"> Impuestos: </div>
                  <div class="fh rc" style="width: 150px; font-size: 11px; color:#5D6770"> ${{impuestosTotal | formatMoney}} </div>
                </div>
                <div class="fh cc" style="margin-right: 40px">
                  <div style="font-size: 14px; color:#5D6770"> Total: </div>
                  <div class="fh rc" style="width: 150px; font-size: 14px; color:#5D6770"> ${{subtotal - descuentosCP + impuestosTotal | formatMoney}} </div>
                </div>
            </div>

            <div id="btnContainer">
                <input id="btnReplicar" @click="btnReplicar" type="submit" value="REPLICAR">
            </div>

        </div>
        </div>
    </div>


    <!--mobile view-->
    <div v-if='mobileView'>
      <div class="fv ct" style="width: 100vw; height:100vh; margin-top:40px">
        <div class="fh cc" style="width: 100%; height:4%; background:#44C7F4; color:white; font: size 12px;">Ver Pedido</div>
        <div class="fh cc" style="width: 100%; height: 40px; margin-top:0px; background:#ffffff;"> 
            <div :id="`circulo${estadoPedido}`"  style="margin-left:10px"> </div>
            <div style="font-size: 12px; font-weight: 400; color:#5D6770; margin-right: 26px">{{estado(estadoPedido)}} </div>
        </div>
        <div class="fh rc" style="width: 100%; height: 50px; margin-top: 0px; background:#eeeeee;"> 
            <div class="fh rc" style="width: 100%; height: 100%"> 
                <div class="fv cc" style="width: 33%; height: 100%"> 
                    <div class="fh cb" style="width: 100%; height: 50%; font-size: 12px; color:#5D6770;">Subtotal</div>    
                    <div class="fh ct" style="width: 100%; height: 50%; font-size: 12px; color:#5D6770;">${{subtotal | formatMoney}}</div>
                </div>    
                <div class="fv cc" style="width: 33%; height: 100%"> 
                    <div class="fh cb" style="width: 100%; height: 50%;  font-size: 12px; color:#5D6770;">Descuentos</div>                  
                    <div class="fh ct" style="width: 100%; height: 50%; font-size: 12px; color:#5D6770;"> -${{descuentosCP | formatMoney}}</div>
                </div>    

                <div class="fv cc" style="width: 33%; height: 100%"> 
                    <div class="fh cb" style="width: 100%; height: 50%;  font-size: 12px; color:#5D6770;">Impuestos</div>                  
                    <div class="fh ct" style="width: 100%; height: 50%; font-size: 12px; color:#5D6770;"> ${{impuestosTotal | formatMoney}}</div>
                </div>    


                <div class="fv cc" style="width: 33%; height: 100%"> 
                    <div class="fh cb" style="width: 100%; height: 50%;  font-size: 15px; font-weight: 500; color:#5D6770;">Total</div>    
                    <div class="fh ct" style="width: 100%; height: 50%; font-size: 12px; color:#5D6770; font-weight: 500;">${{subtotal - descuentosCP  + impuestosTotal| formatMoney}}</div>
                </div>    
            </div>
        </div>
        <div class="fv ct" style="width: 100%; height:60%; overflow: auto; margin-top: 20px;">
          <item-pedido id="list-prod" v-for="item in productosCP" :item='item'></item-pedido>
        </div>
        <div class="fh cc btnFull1" style="font-weight: 500; margin-top: 10px" @click="btnReplicar">REPLICAR</div>
      </div>
    </div>

  </div>

</template>


  <script>
    import axios from 'axios'
    import HeaderSales from '@components/views/header.vue';
    import ItemPedido from '@components/views/estadoPedido/itemPedidoCms.vue';


    export default {
      name: 'Pedido',
      components:{
       'header-sales': HeaderSales,
       'item-pedido': ItemPedido,
      },


      data() {
         return {
           productos:[],
           descuentos:[],
           descuentosV2:[],
           replicaPedido:[],
           pedido:null,
           mobileView:false,
           descuentoImporte: 0 
         }
      },


      computed: {
        numeroPedido(){
          if (this.pedido != null)
          {
            return this.pedido.Numero
          }
          else
          {
            return 0
          }
        },

        fechaPedido(){
          if (this.pedido != null)
          {
            return this.pedido.Fecha
          }
          else
          {
            return ''
          }
        },

        items () {
          return this.$store.state.pedido.carrito;
        },

        productosCP () {
          var totalImpuestos = 0
          var arrayDesc = []
          this.productos.forEach((element) => {
            element.tipoOblea = 1;
            /*******/
            // var impuesto = element.Precio * (Number(element.PorcentajeImpuesto) / 100)         
            // element.Precio = element.Precio + impuesto
            // totalImpuestos = totalImpuestos + impuesto         
            /*******/
          });


          // descuentos
        //   var descuentoNombre =  ' '
        //   this.descuentos.forEach((element) => {
        //     var d = { 
        //         ImagenUrl:'',
        //         Cantidad:1,
        //         Descuento:0,
        //         ProductoId:0,
        //         Precio: element.DescuentoImporte,
        //         ProductoNombre: element.DescuentoNombre,
        //         tipoOblea:2
        //     }
        //     arrayDesc = arrayDesc.concat(d)
        //     this.descuentoImporte = element.DescuentoImporte + this.descuentoImporte
        //     descuentoNombre = element.DescuentoNombre
        //   });


          // descuentosV2
          var descuentoNombre =  ' '
          this.descuentosV2.forEach((element) => {
            var d = { 
                ImagenUrl:'',
                Cantidad:1,
                Descuento:0,
                ProductoId:0,
                Precio: element.DescuentoImporte,
                ProductoNombre: element.DescuentoNombre,
                tipoOblea:2
            }
            arrayDesc = arrayDesc.concat(d)
            this.descuentoImporte = element.DescuentoImporte + this.descuentoImporte
          });



          // acuerdos comerciales
          var ac = {
                ImagenUrl:'',
                Cantidad:1,
                Descuento:0,
                ProductoId:0,
                Precio: this.$store.state.pedido.pedidoId.DescuentoComercialImporte,
                ProductoNombre:'Acuerdo Comercial Descuento '+this.$store.state.pedido.pedidoId.DescuentoComercialPorcentaje+'%',
                tipoOblea:2
            }

          if ((this.$store.state.pedido.pedidoId.DescuentoComercialImporte>0) || (this.$store.state.pedido.pedidoId.DescuentoComercialPorcentaje)) {
            arrayDesc.push(ac);   
          }


          /*********************/
          // impuestos
          var imp = {
                ImagenUrl:'',
                Cantidad:1,
                Descuento:0,
                ProductoId:0,
                Precio: totalImpuestos,
                ProductoNombre:'Impuestos',
                tipoOblea:2
            }

          if (totalImpuestos > 0) {
            arrayDesc.push(imp);   
          }
          var aux = this.productos.concat(arrayDesc); 
          /*********************/

          return aux;    
        },


        descuentosCP() {
            return this.$store.state.pedido.pedidoId.DescuentoComercialImporte + this.descuentoImporte
        },


        impuestosTotal() {
            if (this.pedido) {
                return this.pedido.ImpuestoTotal
            }
            else {
                return 0
            }
        },

        estadoPedido() {
            if (this.pedido != null) {
               return this.pedido.Estado
            }
            else {
               return ''
            }
        },


        subtotal () {
          var st= 0.0;
          this.productos.forEach((element) => {
            st = st + element.Precio * element.Cantidad;
          });
          return st;
        },
        
        total () {
          return this.pedido ? this.pedido.MontoTotal : 0.0
        }

      },


    methods: {

      onResize() {
        if (window.innerWidth > 600) 
        {
          this.mobileView=false;
        }
        else 
        {
          this.mobileView=true;
        }
      },


      estado(e){
          if (e==0)
          {
            return 'PENDIENTE';  
          }
          else if (e==1)
          {
            return 'CONFIRMADO';  
          }
          else if (e==2)
          {
            return 'ELIMINADO ';  
          }
          else if (e==3)
          {
            return 'PROCESANDO ';  
          }
          else if (e==99)
          {
            return 'GUARDADO ';  
          }
        },


      getPedido() {
        this.$store.commit('loader/start')
        // var url = '/WebSalesPedidosListado/'+String(this.$store.state.pedido.pedidoId.Id)+'?Tipo=1'
        var url = '/WebSalesPedidosListado?Id='+String(this.$store.state.pedido.pedidoId.Id)+'&Tipo=1'
        axios.get(url,{
          headers:{
                    Token:        this.$store.state.user.usuario.Token,
                    ClientSecret: this.$store.state.entorno.clientSecret,
                    EmpresaId:    this.$store.state.entorno.idEmpresa
                  }
        })
        .then((response) => {
            this.$store.commit('loader/stop')
            if (response.data.Code == 0) {
              console.log(response.data) 
              this.pedido = response.data
              this.productos = response.data.Productos
              this.descuentos = response.data.Descuentos
              this.descuentosV2 = response.data.Descuentosv2
            }
            else {
               var obj = {
                      txt:response.data.Message,
                      txtBtnCancel:'',
                      txtBtnOk:'Aceptar',
                      fCancel:null,
                      fOk:null
                }
               this.$store.commit('popup/open',obj);
            }
        },
        (error) => {
           alert(error);
        })
      },

      btnReplicar() {
        if (this.$store.state.pedido.carrito.length > 0)
        {
          var obj = {
                      txt:'Existe un nuevo pedido en curso, si replica el pedido actual los ítems cargados en el nuevo pedido se perderán.',
                      txtBtnCancel:'Cancelar',
                      txtBtnOk:'Replicar',
                      fCancel:null,
                      fOk:this.replicarPedido
                    }
          this.$store.commit('popup/open',obj);
        }
        else
        {
          this.replicarPedido();
        }
      },



      replicarPedido() {
        this.$store.commit('pedido/eliminarPedido');

        // replica productos
        this.productos.forEach((e) => {
          var prod = this.$store.state.pedido.productos.find( elem => elem.Id === e.ProductoId)
          if (prod != null)
          {
            var nuevoProducto = {
              id: prod.Id,
              idCategoria: prod.Categorizacion1Id,
              idSubcategoria: prod.Categorizacion2Id,
              producto: prod.Nombre,
              descripcion: prod.Nombre,
              precioLista: prod.Precio,
              precio: prod.Precio,
              descuento: 0,
              porcentajeDescuento: 0,
              cantidad: e.Cantidad,
              peso:prod.Peso,
              ImagenUrl:prod.ImagenUrl,
              promocionId:0,
              unidadesPorPedido:prod.UnidadesPorPedido,
              unidadesMinimaVenta:prod.UnidadesMinimaVenta,
              permiteDecimales:prod.CantidadPermiteDecimales,
              porcentajeImpuesto: prod.PorcentajeImpuesto,
              tipoOblea:1
              }
            this.replicaPedido.push(nuevoProducto);
          }
        })

        // replica promociones
        this.productos.forEach((e) => {                                                   
          var promocion = this.$store.state.pedido.promociones.find( elem => elem.Id === e.PromocionId)

          if (promocion != null)
          {
            var imagen = ''
            if (promocion.ArchivosId != null  && promocion.ArchivosId >= 1)
            {
              imagen = promocion.ArchivosId[0]
            }

            var nuevaPromocion = {
              id: 0,
              idCategoria: 0,
              idSubcategoria: 0,
              producto:promocion.Nombre,
              descripcion:promocion.Nombre,
              precio:promocion.PrecioPromocional,
              descuento: 0,
              porcentajeDescuento: 0,
              cantidad: e.Cantidad,
              peso:promocion.Peso,
              ImagenUrl:imagen,
              promocionId:promocion.Id,
              tipoOblea:1
              }
            this.replicaPedido.push(nuevaPromocion);
          }
        })

        this.$store.commit('pedido/replicarPedido',this.replicaPedido);
        this.$router.push({name: 'pedido'});
      }

    },

    mounted() {
      this.$store.commit('loader/stop')
      this.onResize()
      this.getPedido();
    },

    created() {
       window.addEventListener('resize', this.onResize)
    },

    beforeDestroy() {
       window.removeEventListener('resize', this.onResize)
    }

  }


  </script>


  <style scoped>

  .boton:hover { cursor: pointer; }
  #btnClose:hover { cursor: pointer; }



  .fadePro-enter {
    opacity: 0;
  }
  .fadePro-enter-active {
    transition: opacity 0.5s;
  }
  .fadePro-enter-to {
    opacity: 1;
  }
  .fadePro-leave {
    opacity: 1;
  }
  .fadePro-leave-active {
    transition: opacity 0.1s;
  }
  .fadePro-leave-to {
    opacity: 0;
  }


  /*----------------------------*/

   #subheader {
   width: 100%;
   height: 35vh;
   background: linear-gradient(#005A9F , #1899D6);
   }


 #main-container{
  position: absolute;
  top: 55vh;
  left: 50%;
  transform: translate(-50%,-50%);
  width: 700px;
  height: 85vh;
 }


.label-total{
 font-size: 16px;
 color:#5D6770;
}

.label-subtotal{
 font-size: 12px;
 color:#5D6770;
}


/*pendinte 0 */
  #circulo0 {
    width: 15px;
    height:15px;
    display: block;
    border-radius: 100%;
    background: #FFC107;  
    margin: 5px;
   }
  

  /*confirmado 1*/
  #circulo1 {
    width: 15px;
    height:15px;
    display: block;
    border-radius: 100%;
    background: #4CD964;  
    margin: 5px;
  }
 
  
  
  /*eliminado 2*/
  #circulo2 {
    width: 15px;
    height:15px;
    display: block;
    border-radius: 100%;
    background: red;  
    margin: 5px;
  }
    
  
  /*procesanso 3*/
  #circulo3 {
    width: 15px;
    height:15px;
    display: block;
    border-radius: 100%;
    background: yellow;  
    margin: 5px;
  }
    
  
  /*guardado 99*/
  #circulo99 {
    width: 15px;
    height:15px;
    display: block;
    border-radius: 100%;
    background: #D0D2D3;  
    margin: 5px;
  }


 #label-container{
  width: 700px;
  height: 10vh;

 }

  #label{
  color:#ffffff;
  font-size: 27px;
 }

  #container{
   width: 700px;
   height: 75vh;
   border-width: 1px;
   border: 1px solid #dddddd;
   box-sizing: border-box;
   box-shadow: 3px 3px 4px #dddddd;
   background-color: #ffffff;
   display: flex;
   flex-direction:column;
   align-items: center;
  }

  #list-container{
   width: 660px;
   height: 50vh;
   background: #ffffff;
   overflow: auto;
   display: flex;
   flex-direction:column;
   align-items: center;
   }


 #total-container{
  width: 660px;
  height: 7vh;
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  align-items: center;
}

.label2{
  font-size: 14px;
  color:#5D6770;
 }


#btnContainer{
  width: 660px;
  height: 7vh;
  display: flex;
  flex-direction:row;
  justify-content: flex-end;
  align-items: center;
}


  #btnReplicar{
    width: 120px;
    height: 30px;
    font-size: 9px;
    border-style: solid;
    border:none;
    background: #44C7F4;
    border-radius: 20px;
    color: #ffffff;
  }



  input[type="submit"]:hover
  {
    cursor: pointer;
  }


/* width */
  ::-webkit-scrollbar {
      width: 5px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px #dddddd;
      border-radius: 10px;
  }


  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #bbbbbb;
      border-radius: 10px;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #cccccc;
  }


  ::-webkit-scrollbar {
  display: block; }


  </style>



// WEBPACK FOOTER //
// src/components/views/estadoPedido/pedidoCms.vue